// React
import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Line from './Line'
import LinesSkeleton from './LineSkeleton'
import { Lines as LinesContainer, EmptyText, HostStyles } from './styles'
import Div from 'ui/elements/Div'

// Libraries
import _flatten from 'lodash/flatten'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { withTranslation } from 'shared/utils/withTranslation'
import ItemActions from 'back_office/v2/redux/actions/item_actions'
import LineActions from 'back_office/v2/redux/actions/line_actions'
import ClientActions from 'store/v2/redux/actions/client'

const Lines = ({ cartId, lines, fetchLines, fetchContents, t }) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('periodPicker') === 'opened') {
      ClientActions.toggleModalPicker(true)
    }
  }, [])

  useEffect(() => {
    setLoading(true)

    fetchLines(cartId)
      .then(({ payload }) => {
        const ids = _flatten(
          payload.response.data.map(({ attributes }) => attributes.items.map(({ item_id: id }) => id))
        )

        if (!ids.length) return

        fetchContents(ids)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [cartId])

  if (loading) {
    return (
      <Fragment>
        <HostStyles />
        <LinesSkeleton />
      </Fragment>
    )
  }

  if (!lines.size()) {
    return (
      <Fragment>
        <HostStyles />
        <Div modifiers="display-flex justify-center align-center padding-top-lg padding-bottom-lg">
          <EmptyText>{t('user.cart.empty')}</EmptyText>
        </Div>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <HostStyles />
      <LinesContainer>
        {lines?.map((line) => (
          <Line key={line.id} id={line.id} />
        ))}
      </LinesContainer>
    </Fragment>
  )
}

Lines.propTypes = {
  cartId: PropTypes.string,
  lines: PropTypes.object,
  fetchLines: PropTypes.func,
  fetchContents: PropTypes.func,
  t: PropTypes.func
}

const mapStateToProps = (state, _props) => {
  const cartId = state.client.cartId

  const cart = state.orm.carts.getById(cartId)
  const lines = state.orm.lines.getAll({ id: cart?.lines }).filter(({ product_type: type }) => type !== 'service')

  return { cartId, lines }
}

const mapDispatchToProps = (_dispatch, _props) => {
  return {
    fetchLines: (id) => {
      return LineActions.fetchAll({
        apiVersion: 'boomerang',
        include: [
          'item',
          'item.photo',
          'item.bundle_items',
          'item.bundle_items.product',
          'item.bundle_items.product.photo'
        ],
        filter: {
          owner_id: id
        }
      })
    },
    fetchContents: (ids) => {
      return ItemActions.fetchAll({
        apiVersion: 'boomerang',
        include: ['photo'],
        filter: {
          id: ids,
          archived: false
        }
      })
    }
  }
}

const decoratedComponent = compose(
  withStore,
  withTheme,
  withTranslation('user'),
  reduxConnect(mapStateToProps, mapDispatchToProps)
)(Lines)

registerCustomElement('bq-cart-lines', decoratedComponent)

export default decoratedComponent
